<div class="orgUnitMaster">
  <h3>Organization</h3>
  <input autofocus class="standardTextBox" [(ngModel)]="searchTerm" placeholder="Search" (keyup)="handleKeyUp($event)"/>
  <button class="standardButton" [disabled]="(isBusy() || !searchTerm || searchTerm.length < 3)" (click)="search()">Search</button>
  <button class="standardButton" [disabled]="isBusy()" (click)="newOrganization()">New Organization</button>
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (searchResults()) {
    <div class="results">
      <table class="orgSearchResults reportTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">ID</td>
            <td class="tableCell centeredCell headerCell">Name</td>
            <td class="tableCell centeredCell headerCell">Description</td>
            <td class="tableCell centeredCell headerCell">Parent ID</td>
            <td class="tableCell centeredCell headerCell">Parent Name</td>
          </tr>
        </thead>
        @for (result of searchResults(); track result) {
          <tr>
            <td class="tableCell"><a routerLink="/organization/{{result.orgUnitId}}">{{ result.orgUnitId }}</a></td>
            <td class="tableCell">{{ result.orgUnitName }}</td>
            <td class="tableCell">{{ result.description }}</td>
            <td class="tableCell">{{ result.controllingOrgUnitId }}</td>
            <td class="tableCell">{{ result.controllingOrgUnitDescription }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
